import '../scss/app.scss'

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

import Accordion from "accordion-js";
import "accordion-js/dist/accordion.min.css";

import MicroModal from 'micromodal';

gsap.registerPlugin(ScrollTrigger,ScrollToPlugin);
/*
import Lenis from 'lenis'
const lenis = new Lenis({
  autoRaf: true,
});
*/

setTimeout(()=>{
    if (document.querySelectorAll('.stagger-in').length > 0) {

        document.querySelectorAll('.stagger-in').forEach(el=>{


            let elements = el.querySelectorAll('.stagger-in__el')


            gsap.from(elements, {
                opacity: 0,
                duration: .8,
                yPercent:50,
                stagger: {
                    each: 0.2
                },
                scrollTrigger: {
                    trigger: el,
                    start: "top 75%",
                }
            });

            gsap.to(elements, {
                opacity: 1,
                duration: .8,
                yPercent:0,
                stagger: {
                    each: 0.2
                },
                scrollTrigger: {
                    trigger: el,
                    start: "top 75%",
                }
            });

        });
    }

},200); 


setTimeout(()=>{
    if (document.querySelectorAll('.stagger-left').length > 0) {

        document.querySelectorAll('.stagger-left').forEach(el=>{


            let elements = el.querySelectorAll('.stagger-left__el')


            gsap.from(elements, {
                opacity: 0,
                duration: 1,
                yPercent:0,
                xPercent:50,
                stagger: {
                    each: 0.2
                },
                scrollTrigger: {
                    trigger: el,
                    start: "top 60%",
                }
            });

            gsap.to(elements, {
                opacity: 1,
                duration: 1,
                delay: 1,
                yPercent:0,
                xPercent:0,
                stagger: {
                    each: 0.2
                },
                scrollTrigger: {
                    trigger: el,
                    start: "top 60%",
                }
            });

        });
    }

},200); 

const header = document.querySelector("header");
const menuAnimation = gsap.to("header", {
    yPercent: -100,
    ease: "none",
    scrollTrigger: {
        trigger: "body",
        start: "top top",
        end: "+=200",   
        scrub: true  
    } 
});

ScrollTrigger.create({
  trigger: ".hero",
  start: "top top",
  end: "bottom top",
  onEnter: () => {
    // Quando si supera completamente la Hero andando verso il basso
  },
  onLeaveBack: () => {
      menuAnimation.reverse();
      header.classList.remove("header-scrolled", "is-hidden");
    }, 
  onLeave: () => {
    menuAnimation.reverse();
    header.classList.add("header-scrolled");
    },
  // Opzionale: nasconde il menu non appena si inizia a scorrere verso il basso dentro la hero
  onUpdate: (self) => {
    if (self.progress > 0 && self.direction === 1 && !self.isEnded) {
        menuAnimation.play();
    }
    else{
        header.classList.remove("header-scrolled", "is-hidden");
    }
  }
});


if (document.querySelectorAll('.swiper-sapori').length > 0) {
    var swiper = new Swiper(".swiper-sapori", {
      loop: false,
      slidesPerView: 1.3,
      centeredSlides: false,
      spaceBetween: 16,
      slidesOffsetAfter: 16,
      slidesOffsetBefore: 16,
      freeMode: true,
      navigation: {
        nextEl: ".btn-sapori.swiper-button-next",
        prevEl: ".btn-sapori.swiper-button-prev",
      },
      breakpoints: {
          640: {
            slidesPerView: 1.3,
            spaceBetween: 16,
            slidesOffsetAfter: 16,
            slidesOffsetBefore: 16,
          },
          768: {
            slidesPerView: 1.8,
            spaceBetween: 16,
            slidesOffsetAfter: 16,
            slidesOffsetBefore: 16,
          },
          1024: {
            slidesPerView: 2.1,
            spaceBetween: 32,
            slidesOffsetAfter: 32,
            slidesOffsetBefore: 32,
          },
          1300: {
            slidesPerView: 2.2,
            spaceBetween: 32,
            slidesOffsetAfter: 32,
            slidesOffsetBefore: 32,
          },
      },
    });
}

if (document.querySelectorAll('.swiper-news').length > 0) {
    var swiper2 = new Swiper(".swiper-news", {
      loop: true,
      spaceBetween: 8,
      freemode: "true",
      slidesPerView: 1.4,
      slidesOffsetAfter: 8,
      navigation: {
        nextEl: ".swiper-button-next.btn-news",
        prevEl: ".swiper-button-prev.btn-news",
      },
      breakpoints: {
        650: {
          slidesPerView: 1.8,
          spaceBetween: 8,
          slidesOffsetAfter: 8,
        },
        768: {
          slidesPerView: 2.6,
          spaceBetween: 12,
          slidesOffsetAfter: 12,
        },
        960: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        1300: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
      }, 
    });
}

if (document.querySelectorAll('.swiper-gallery').length > 0) {
    var swiper3 = new Swiper(".swiper-gallery", {
      loop: false,
      spaceBetween: 8,
      slidesPerView: 1.2,
      slidesOffsetAfter: 8,
      navigation: {
        nextEl: ".swiper-button-next.btn-gallery",
        prevEl: ".swiper-button-prev.btn-gallery",
      },
      breakpoints: {
        640: {
          slidesPerView: 1.2,
          spaceBetween: 8,
          slidesOffsetAfter: 8,
        },
        1200: {
          slidesPerView: 1.3,
          spaceBetween: 24,
          slidesOffsetAfter: 24,
        },
        1500: {
          slidesPerView: 1.4,
          spaceBetween: 32,
          slidesOffsetAfter: 32,
        },
      }, 
    });
}

if (document.querySelectorAll('.parallax-bg').length > 0) { 
    gsap.to(".parallax-bg", {
      yPercent: -20,
      ease: "none",  
      scrollTrigger: {
        trigger: ".parallax-container",
        start: "top bottom", 
        end: "bottom top",   
        scrub: true         
      }
    });
}

if (document.querySelectorAll('.accordion-container').length > 0) {  
    const accordions = Array.from(document.querySelectorAll(".accordion-container"));
    new Accordion(accordions, {});   
}

if (document.querySelectorAll('.idTabs').length > 0) {
    document.addEventListener("DOMContentLoaded", () => {
      const containers = document.querySelectorAll('.idTabs');

      containers.forEach(container => {
        const links = container.querySelectorAll('a[href^="#"]');
        
        links.forEach((link, index) => {
          const targetId = link.getAttribute('href');
          const targetEl = document.querySelector(targetId);
          
          if (targetEl) {
            if (index === 0) {
              link.classList.add('selected');
              targetEl.style.display = 'block';
            } else {
              // Altrimenti nascondilo
              targetEl.style.display = 'none';
            }
          }

          link.addEventListener('click', (e) => {
            e.preventDefault();

            links.forEach(l => {
              l.classList.remove('selected');
              const t = document.querySelector(l.getAttribute('href'));
              if (t) t.style.display = 'none';
            });

            link.classList.add('selected');
            if (targetEl) targetEl.style.display = 'block';
          });
        });
      });
    });
}

document.addEventListener('DOMContentLoaded', function() {
    const filterTipologia = document.getElementById('filter-tipologia');
    const filterBrand = document.getElementById('filter-brand');
    const productsContainer = document.getElementById('products-container');
    const paginationContainer = document.getElementById('pagination-container');
    const header = document.querySelector('header');

    const modalConfig = {
        openClass: 'is-open',
        disableScroll: true,
        disableFocus: false,
        onShow: modal => {
            if (header) {
                header.classList.add('is-hidden'); 
            }
        },
        onClose: modal => {
            if (header) {
                header.classList.remove('is-hidden'); 
            }
        }
    };

    document.addEventListener('click', function(e) {
        const trigger = e.target.closest('[data-micromodal-trigger]');
        if (trigger) {
            e.preventDefault();
            const modalId = trigger.getAttribute('data-micromodal-trigger');
            if (typeof MicroModal !== 'undefined') {
                MicroModal.show(modalId, modalConfig);
            }
            return;
        }

        const closeTrigger = e.target.closest('[data-micromodal-close]');
        if (closeTrigger) {
            const modalEl = closeTrigger.closest('.micromodal-slide');
            if (modalEl && typeof MicroModal !== 'undefined') {
                MicroModal.close(modalEl.id);
            }
        }
    });

    function loadProducts(page = 1) {
        if (!productsContainer) return;

        const tipologia = filterTipologia ? filterTipologia.value : '';
        const brand = filterBrand ? filterBrand.value : '';

        const currentTermIdEl = document.getElementById('current-term-id');
        const currentTaxonomyEl = document.getElementById('current-taxonomy');

        const currentTermId = currentTermIdEl ? currentTermIdEl.value : '';
        const currentTaxonomy = currentTaxonomyEl ? currentTaxonomyEl.value : '';

        productsContainer.style.opacity = '0.5';

        const formData = new FormData();
        formData.append('action', 'filter_products');
        formData.append('tipologia', tipologia);
        formData.append('brand', brand);
        formData.append('current_term_id', currentTermId);
        formData.append('current_taxonomy', currentTaxonomy);
        formData.append('page', page);

        const ajaxUrl = (typeof ajax_params !== 'undefined' && ajax_params.ajax_url)
            ? ajax_params.ajax_url
            : '/wp-admin/admin-ajax.php';

        fetch(ajaxUrl, {
            method: 'POST',
            body: formData
        })
        .then(response => {
            if (!response.ok) throw new Error('Errore nella risposta della rete');
            return response.json();
        })
        .then(data => {
            if (data.success) {
                productsContainer.innerHTML = data.data.products;
                productsContainer.style.opacity = '1';

                if (paginationContainer) {
                    paginationContainer.innerHTML = data.data.pagination;
                }
            } else {
                productsContainer.innerHTML = '<p class="col-12">Nessun prodotto trovato.</p>';
                productsContainer.style.opacity = '1';
            }
        })
        .catch(error => {
            console.error('Errore durante il caricamento AJAX:', error);
            productsContainer.innerHTML = '<p class="col-12 text-danger">Si è verificato un errore nel caricamento dei prodotti.</p>';
            productsContainer.style.opacity = '1';
        });
    }

    if (filterTipologia) filterTipologia.addEventListener('change', () => loadProducts(1));
    if (filterBrand) filterBrand.addEventListener('change', () => loadProducts(1));

    if (paginationContainer) {
        paginationContainer.addEventListener('click', function(e) {
            const link = e.target.closest('a');
            if (!link) return;

            e.preventDefault();
            let page = link.textContent.trim();

            if (isNaN(page)) {
                const currentPageEl = paginationContainer.querySelector('.current');
                let currentPage = currentPageEl ? parseInt(currentPageEl.textContent.trim()) : 1;

                if (link.classList.contains('next')) page = currentPage + 1;
                if (link.classList.contains('prev')) page = currentPage - 1;
            }

            loadProducts(page);
        });
    }

    loadProducts(1);
});


if (document.querySelectorAll('#news-container').length > 0) { 
    let page = 1;
    let category = '';
    
    const container = document.getElementById('news-container');
    const loadMoreBtn = document.getElementById('load-more-btn');
    const filterLinks = document.querySelectorAll('#category-filter-list a');

    async function loadNews(append = false) {
        const formData = new FormData();
        formData.append('action', 'load_more_news');
        formData.append('page', page);
        formData.append('category', category);

        loadMoreBtn.textContent = 'Loading...';
        loadMoreBtn.disabled = true;

        try {
            const response = await fetch(ajax_posts.ajaxurl, {
                method: 'POST',
                body: formData
            });
            const html = await response.text();

            if (html.trim() !== '') {
                if (append) {
                    container.insertAdjacentHTML('beforeend', html);
                } else {
                    container.innerHTML = html;
                }
                loadMoreBtn.textContent = 'Carica altre news';
                loadMoreBtn.disabled = false;
                loadMoreBtn.style.display = 'block';
                page++;
            } else {
                if (!append) container.innerHTML = '<p class="text-center">Nessun articolo trovato.</p>';
                loadMoreBtn.style.display = 'none';
            }
        } catch (error) {
            console.error('Errore:', error);
        }
    }

    filterLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();

            // Rimuovi classe active dagli altri e aggiungila a questo
            filterLinks.forEach(l => l.classList.remove('active'));
            this.classList.add('active');

            // Aggiorna categoria e resetta pagina
            category = this.getAttribute('data-category');
            page = 1;
            loadNews(false);
        });
    });

    loadMoreBtn.addEventListener('click', () => loadNews(true));
    loadNews(); 
}


const openButton = document.querySelector('.open-menu');
const closeButton = document.querySelector('.close-menu');
const menuOverlay = document.querySelector('.menu-overlay');
const menuItems = document.querySelectorAll('.menu-overlay li');

// Timeline principale di GSAP (inizialmente in pausa)
const menuTL = gsap.timeline({ 
  paused: true,
  onStart: () => {
    menuOverlay.style.display = 'flex';
    openButton.setAttribute('aria-expanded', 'true');
  },
  onReverseComplete: () => {
    menuOverlay.style.display = 'none';
    openButton.setAttribute('aria-expanded', 'false');
  }
});

// Configurazione della sequenza di animazione
menuTL
  .fromTo(menuOverlay, 
    { left: '-100%', opacity: 0 }, 
    { left: '0%', opacity: 1, duration: 0.4, ease: 'power2.out' }
  )
  .fromTo(menuItems, 
    { opacity: 0, x: -50 }, 
    { opacity: 1, x: 0, duration: 0.3, stagger: 0.08, ease: 'power1.out' },
    '-=0.2' // Sovrappone leggermente le animazioni per maggiore fluidità
  );

// Event Listeners
openButton.addEventListener('click', () => menuTL.play());
closeButton.addEventListener('click', () => menuTL.reverse());

// Chiudi il menu premendo il tasto ESC (Accessibilità)
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && menuTL.progress() > 0) {
    menuTL.reverse();
  }
});

